import getInstanceAxios from '../Request';

const baseDomain = process.env.REACT_APP_BLOG_STYLE;
const baseURL = `${baseDomain}/`;

export default getInstanceAxios(baseURL);
